module.exports = __webpack_public_path__ + "img/logo-reverse.1915a336.png";